import { PostalAddress } from '../interfaces/PostalAddress';

// Google Places puede devolver long_name con entidades HTML (ej. "C&Aacute;diz");
// el navegador las decodifica de forma nativa y sin ejecutar el HTML.
const decodeHtmlEntities = (value: string): string => {
  if (!value) return value;
  const textarea = document.createElement('textarea');
  textarea.innerHTML = value;
  return textarea.value;
};

export const identifyAddressTypes = (place: []) => {
  let newAddress = {
    road_type: '',
    address: '',
    number: '',
    aux: '',
    province: '',
    postal_code: '',
    city: '',
  } as PostalAddress;
  // eslint-disable-next-line array-callback-return
  place.map((data: any) => {
    const longName = decodeHtmlEntities(data.long_name);
    switch (data.types[0]) {
      case 'street_number':
        newAddress.number = longName;
        break;
      case 'route':
      case 'street_address': {
        let street = longName.split(' ');
        const type = getRoadType(street[0]);
        newAddress.address = longName;
        newAddress.road_type = type;
        break;
      }
      case 'locality':
        // Google a veces corrompe el locality con una entidad HTML truncada
        // (ej. "C&Aacute" en Cádiz); si viene así lo descartamos y caemos a la provincia.
        newAddress.city = /&[a-z]+;?/i.test(data.long_name) ? '' : longName;
        break;
      case 'administrative_area_level_2':
        newAddress.province = longName;
        break;
      case 'administrative_area_level_1':
        if (!newAddress.province) {
          newAddress.province = longName;
        }
        break;
      case 'postal_code':
        newAddress.postal_code = longName;
        break;
      default:
        break;
    }
  });
  // Fallback: si el locality vino corrupto/vacío, usamos la provincia (llega limpia).
  if (!newAddress.city && newAddress.province) {
    newAddress.city = newAddress.province;
  }
  if (newAddress.road_type !== 'ZZ') {
    let splitAddress = newAddress.address.split(' ');
    splitAddress.shift();
    let updatedAddress = splitAddress.join(' ');
    newAddress.address = updatedAddress;
  }
  return newAddress;
};

export const getRoadType = (type: string) => {
  switch (type) {
    case 'Alameda o Aldea':
    case 'Alameda':
    case 'Aldea':
      return 'AL';
    case 'Apartamento':
      return 'AP';
    case 'Avenida':
      return 'AV';
    case 'Bloque':
      return 'BL';
    case 'Barrio':
      return 'BO';
    case 'Chalet':
      return 'CH';
    case 'Carrer':
    case 'Calle':
      return 'CL';
    case 'Camino':
      return 'CM';
    case 'Colonia':
      return 'CO';
    case 'Carretera':
      return 'CR';
    case 'Caserío':
      return 'CS';
    case 'Cuesta':
      return 'CT';
    case 'Edificio':
      return 'ED';
    case 'Glorieta':
      return 'GL';
    case 'Grupo':
      return 'GR';
    case 'Lugar':
      return 'LG';
    case 'Mercado':
      return 'MC';
    case 'Municipio':
      return 'AV';
    case 'Manzana':
      return 'MZ';
    case 'Poblado':
      return 'PB';
    case 'Polígono':
      return 'PG';
    case 'Pasaje':
      return 'PJ';
    case 'Parque':
      return 'PQ';
    case 'Plaza':
      return 'PZ';
    case 'Prolongación':
      return 'PR';
    case 'Paseo':
      return 'PS';
    case 'Rambla':
      return 'RB';
    case 'Ronda':
      return 'RD';
    case 'Travesía':
      return 'TR';
    case 'Urbanización':
      return 'UR';
    default:
      return 'ZZ';
  }
};
